import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { MdOutlineGroup } from 'react-icons/md';
import { useSelector } from 'react-redux';

import Highlighter from 'react-highlight-words';

import StickyTable from '../../../components/Tables/StickyTable';
import ReferralStatusBtn from '../../../components/statusButtons/referralStatusBtn';
import { getAuth, getUserSource } from '../../../redux/selectors';
import ReferralRepository from '../../../repositories/ReferralRepository';

import isInRole from '../../../utility/helpers/isInRole';
import { useHistory } from 'react-router-dom';
import { createQueryString } from '../../../utility/helpers/serializeQuery';

const SearchReferrals = ({ searchCriteria, toggleModal }) => {
    const sourceId = useSelector(getUserSource);
    const { loggedUser } = useSelector(getAuth);
    const history = useHistory();
    const [searchParams, setSearchParams] = useState({
        page: 0,
        pageSize: 5,
        lawyerId: isInRole(loggedUser.roles, 'lawyer') ? loggedUser.id : null,
    });
    const [loading, setLoading] = useState(false);
    const [referrals, setReferrals] = useState({
        loaded: false,
        list: [],
        totalCount: 0,
    });

    const searchReferrals = async (searchParams) => {
        setLoading(true);

        const { data } = await ReferralRepository.referralGlobalSearch({
            ...searchParams,
            stage: 'referral',
        });

        if (data.success) {
            setReferrals({
                loaded: true,
                list: data.data.list,
                totalCount: data.data.total,
            });
        }
        setLoading(false);
    };

    useEffect(() => {
        searchReferrals({
            searchCriteria,
            page: searchParams.page,
            sourceId,
            lawyerId: searchParams.lawyerId,
        });
    }, [
        searchCriteria,
        sourceId,
        searchParams.page,
        searchParams.lawyerId,
        searchParams.pageSize,
    ]);

    const columns = useMemo(() => {
        return [
            {
                Header: 'Status',
                accessor: (originalRow) => originalRow,
                id: 'status',
                Cell: ({ value }) => {
                    return <ReferralStatusBtn referral={value} />;
                },
                headerStyle: {
                    width: 250,
                },
            },
            {
                Header: 'Client Name',
                id: 'client_name',
                accessor: 'lrsUser',
                Cell: ({ value }) => {
                    // return `${value?.firstName || ''} ${value?.lastName || ''}`;
                    return (
                        <Highlighter
                            searchWords={[`${searchCriteria}`]}
                            autoEscape={true}
                            textToHighlight={`${value?.firstName || ''} ${
                                value?.lastName || ''
                            }`}
                            highlightTag="strong"
                        />
                    );
                },
            },
            {
                Header: 'Legal Issue',
                id: 'area_of_low',
                accessor: 'practiceArea',
                Cell: ({ value }) => {
                    // return practiceAreasCrop(value, 20);
                    return value?.sourceArea?.name || value?.name || '';
                },
            },
            {
                Header: 'Attorney',
                id: 'lawyer_name',
                accessor: 'lawyer',
                Cell: ({ value }) => {
                    return (
                        <Highlighter
                            searchWords={[`${searchCriteria}`]}
                            autoEscape={true}
                            textToHighlight={`${value?.firstName || ''} ${
                                value?.lastName || ''
                            }`}
                            highlightTag="strong"
                        />
                    );
                },
            },
            {
                Header: 'Created Date',
                accessor: 'created',
                Cell: ({ value }) => {
                    return moment(value).format('MM-DD-YYYY');
                },
            },
        ];
    }, [searchCriteria]);

    const formatTrProps = (state = {}) => {
        return {
            onClick: () => {
                let isLawyer = isInRole(loggedUser.roles, 'lawyer');
                let redirectPath = isLawyer
                    ? '/new_referrals'
                    : '/agent_us_referrals';

                let queryObj = isLawyer
                    ? {
                          searchCriteria: state.original.matterId,
                      }
                    : {
                          matterId: state.original.matterId,
                      };

                if (isLawyer) {
                    queryObj['activeTabId'] =
                        state.original.caseStatus === 'Pending' ? 1 : 2;
                }

                if (!isLawyer) {
                    queryObj['isClosed'] = state.original.isClosed
                        ? 'true'
                        : '';
                    //queryObj['statuses'] = state.original.caseStatus;
                }

                history.push({
                    pathname: redirectPath,
                    search: createQueryString(queryObj),
                });
                toggleModal();
            },
            style: {
                cursor: 'pointer',
            },
        };
    };

    if (!loading && referrals.loaded && referrals.totalCount === 0) {
        return null;
    }

    return (
        <div className="mb-5">
            <h4 className="q-fw-500 d-flex align-items-center mb-0">
                <MdOutlineGroup size={24} color="#5A5A5A" className="me-1" />
                Referrals
            </h4>

            <StickyTable
                columns={columns}
                data={referrals.list}
                isSubComponent={false}
                renderRowSubComponent={() => {}}
                pageCount={Math.ceil(
                    referrals.totalCount / searchParams.pageSize,
                )}
                handleSearch={(name, value) => {
                    setSearchParams((prevState) => {
                        return {
                            ...prevState,
                            [name]: value,
                        };
                    });
                }}
                isLoading={loading}
                wrapperStyles={{
                    minHeight: '100px',
                    position: 'relative',
                }}
                formatRowProps={(state) => formatTrProps(state)}
            />
        </div>
    );
};

export default SearchReferrals;
